module.exports = __webpack_public_path__ + "static/media/mediatorDetailActivity.492049d1.jpg";